import $ from 'jquery';
import Overlay from 'blocks/overlay/overlay';

export default class {
	constructor() {
		this.$window = $(window);
		this.$body = $(document.body);
		this.$html = $('html');
		this.$htmlBody = this.$body.add(this.$html);
		this.$section = $('.js-section');
		this.$overlay = $('.js-overlay');
		this.$header = $('#header');

		this.hashPrevent = false;
		this.hashScrollChange = true;
		this.activated = true;
		this.hashes = [];
		this.alternative = [];
		return this;
	}

	scan() {
		const self = this;
		self.$section.add(self.$overlay).each(function () {
			const {hash, alternative} = $(this).data();
			if (hash) {
				self.hashes.push(hash);
			}
			if (alternative && hash) {
				self.alternative.push({
					hash: hash,
					alternative: alternative
				});
			}
		});
		return self;
	}

	checkBase(hash) {
		const self = this;
		const current = hash;
		let base = false;
		let alternative = false;

		$.each(self.hashes, function (index, alt) {
			if (base === false || alt.length > base.length) {
				if (current.indexOf(alt) == 0) {
					base = alt;
					alternative = false;
				}
			}
		});

		$.each(self.alternative, function (index, alt) {
			if (base === false || alt.length > base.length) {
				if (current.indexOf(alt.hash) == 0) {
					base = alt.hash;
					alternative = false;
				} else if (hash.indexOf(alt.alternative) == 0) {
					base = alt.hash;
					alternative = alt.alternative;
				}
			}
		});

		let result = false;
		if (base !== false) {
			result = {base, alternative};
		}
		return result;
	}

	getHash() {
		this.hash = location.hash.substr(1);
		if (this.hash.substring(0, 1) == '/') {
			this.hash = this.hash.substr(1);
		}

		const bases = this.checkBase(this.hash);
		this.params = [];
		if (bases === false) {
			this.hash = '';
		} else {
			let way = this.hash;
			this.hash = bases.base;
			if (bases.alternative !== false) {
				way = way.split(bases.alternative)[1];
			} else {
				way = way.split(bases.base)[1];
			}
			if (way.substring(0, 1) == '/') {
				way = way.substr(1);
			}
			const params = way.split('/');
			for (let i = 0; i < params.length; i++) {
				if ( params[i] !== '') {
					this.params.push(params[i]);
				}
			}
		}
		return this;
	}

	onScroll() {
		const self = this;
		const $overlay = this.overlay.active();
		if (self.hashScrollChange && self.$section.length && $overlay.length == 0) {
			const headerHeight = self.$header.height();
			const windowPosition = window.pageYOffset + headerHeight + (self.$window.height() - headerHeight) / 2;
			const sections = [];
			let hash = false;
			let $el = false;
			let params = [];
			self.$section.each(function () {
				const $section = $(this);
				const top = $section.offset().top;
				sections.push({
					el: $section,
					top: top,
					bottom: top + $section.outerHeight(true),
					hash: $section.data('hash'),
					params: $section.data('params') || []
				});
			});

			$.each(sections, function (key, section) {
				if (section.top <= windowPosition && section.bottom > windowPosition) {
					$el = section.el;
					hash = section.hash;
					params = section.params;
				}
			});

			if (hash !== false) {
				self.setHash(hash, 'section', params);
			}
			if ($el.length) {
				$el.data('activated', true).trigger('yota.router.activate');
			}
		}
		return self;
	}

	onCheckOrverlay() {
		const self = this;
		const $overlay = this.overlay.active();
		let hash = false;
		let params = [];
		if ($overlay.length) {
			hash = $overlay.data('hash');
			params = $overlay.data('params');
		}
		if (hash !== false) {
			self.setHash(hash, 'overlay', params);
		}
		if ($overlay.length) {
			$overlay.data('activated', true).trigger('yota.router.activate');
		}
		return false;
	}


	scrollTo($el, init = false) {
		const self = this;
		const $hashed = $el;
		if (self.hashScrollChange || init) {
			let scrollTop = $hashed.offset().top - self.$header.height();
			if (scrollTop !== window.pageYOffset) {
				self.hashScrollChange = false;
				self.$htmlBody.animate({scrollTop: scrollTop}, 250, function () {
					scrollTop = $hashed.offset().top - self.$header.height();
					if (scrollTop !== window.pageYOffset) {
						self.$htmlBody.animate({scrollTop: scrollTop}, 250, function () {
							self.hashScrollChange = true;
							self.onScroll();
						});
					} else {
						self.hashScrollChange = true;
						self.onScroll();
					}
				});
			} else {
				self.hashScrollChange = true;
				self.onScroll();
			}
		}
	}

	setHash(hash, type, params) {
		let additional = '';
		if (typeof params != 'undefined') {
			additional = params.join('/');
		}

		if (additional != '') {
			additional = '/' + additional;
		}

		if (history.state !== null) {
			if (history.state.hash !== hash + additional) {
				window.history.replaceState({hash: hash + additional, main: hash, params: params}, type, hash !== '' ? '#' + hash + additional : ' ');
				this.$window.data('hash', hash).trigger('yota.router.hash');
			}
		} else {
			window.history.replaceState({hash: hash + additional, main: hash, params: params}, type, hash !== '' ? '#' + hash + additional : ' ');
			this.$window.data('hash', hash).trigger('yota.router.hash');
		}

		return this;
	}

	onOverlayOpen() {
		const $overlay = this.overlay.active();
		if ($overlay.length) {
			const hash = $overlay.data('hash');
			this.hashScrollChange = false;
			this.setHash(hash, 'overlay', ($overlay.data('params') || []));
		} else {
			this.hashScrollChange = true;
		}
		return this;
	}

	onOverlayClose() {
		this.hashScrollChange = true;
		this.onScroll();
		return this;
	}

	init(hash, params) {
		const $hashed = this.$overlay
			.add(this.$section)
			.filter('[data-hash="' + hash + '"]');
		if ($hashed.length) {
			if (params.length) {
				$hashed
					.data('params', params)
					.trigger('yota.router.update');
			} else {
				this.getHash();
			}
			this.scrollTo($hashed, true);
		}
		if ($hashed.length && $hashed.is(this.$overlay)) {
			$hashed.trigger('yota.overlay.open');
		}
		this.$window.data('hash', this.hash);
		this.$window.trigger('yota.router.hash');
	}

	onPopState() {
		this.getHash();
		const $hashed = this.$overlay
			.add(this.$section)
			.filter('[data-hash="' + this.hash + '"]');


		const $overlayActive = this.overlay.active();
		if (!$hashed.length && $overlayActive.length) {
			$overlayActive.trigger('yota.overlay.close');
		}
		if ($hashed.length) {
			if (this.params.length) {
				$hashed
					.data('params', this.params)
					.trigger('yota.router.update');
			} else {
				this.getHash();
			}
			this.scrollTo($hashed, true);
		}

		if ($hashed.length && $hashed.is(this.$overlay)) {
			$hashed.trigger('yota.overlay.open');
		}
		this.$window.data('hash', this.hash).trigger('yota.router.hash');
	}

	render() {
		if (this.$section.length || this.$overlay.length) {
			this.scan();
			this.getHash();
			this.$window
				.on('scroll.router resize.router yota.router.check', this.onScroll.bind(this))
				.on('yota.router.check.overlay', this.onCheckOrverlay.bind(this))
				.on('yota.overlay.open', this.onOverlayOpen.bind(this))
				.on('yota.overlay.close', this.onOverlayClose.bind(this));

			if (window.history && window.history.pushState) {
				this.$window.on('popstate.router hashchange.router', this.onPopState.bind(this));
			} else {
				this.$window.on('hashchange.router', this.onPopState.bind(this));
			}
			this.overlay = new Overlay();
			this.init(this.hash, this.params);
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/modules/router/router.js